// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"99a6d5a1","127":"85c2e2ce","153":"05201992","178":"a79a7795","225":"85c2e2ce","564":"7ad01c99","607":"85c2e2ce","760":"99a6d5a1","917":"2cad6378","979":"7ad01c99"}[chunkId] + ".chunk.css";
};